import './App.css';
import WeatherApp from './components/Weatherapp/WeatherApp';
// import WeatherApp from './components/weatherapp/weatherApp';

function App() {
  return (
    <div className="App">
      <WeatherApp/>
    </div>
  );
}

export default App;
